__turbopack_context__.v({
  "className": "_59ygLW_className",
  "variable": "_59ygLW_variable",
});
